module.exports = __webpack_public_path__ + "static/img/package_bttc.1b7b244a.jpg";